export function Verified({ show }: { show?: boolean }) {
  return show ? <span className="verified" aria-label="Verified Floptropica citizen" title="Verified Floptropica citizen"><img src="/assets/floptropica-citizen-badge.png" alt="" /></span> : null;
}
